module.exports = __webpack_public_path__ + "img/fondoContacto.1ed682db.png";